// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SparklineIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SparklineIcon" ref={forwardedRef} {...props}>
      <path d="m8.366 7.956 3.503-3.47H8.363V3h6.005v5.948h-1.501v-3.35l-3.44 3.408z" />
      <path d="m19 8.564-1.25-1.215-6.268 6.328-4.744-3.421-6.238 6L1.72 17.5l5.18-4.982 4.773 3.443z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SparklineIcon = /* @__PURE__ */ Object.assign(
  SparklineIconComponent,
  { displayName: 'SparklineIcon' },
);
